import { JsonObject, JsonProperty } from "ta-json";

import Guard from "../guard";
import { OAuthGrantBase } from "./oauth-grant-base";
import { OAuthGrantType } from "./oauth-grant-type";

@JsonObject()
export default class OAuthPasswordGrant extends OAuthGrantBase {
    @JsonProperty("grant_type")
    type: OAuthGrantType = OAuthGrantType.Password;

    @JsonProperty("username")
    username: string;

    @JsonProperty("password")
    password: string;

    constructor(clientId: string, clientSecret: string, username: string, password: string) {
        super(clientId, clientSecret);

        Guard.notNullOrUndefined(username);
        Guard.notNullOrUndefined(password);
        this.username = username;
        this.password = password;
    }
}

export { OAuthPasswordGrant };
